'use client'
import { isServer } from './is-server'
export const scrollToTop = (
  behavior: 'instant' | 'auto' | 'smooth' = 'instant'
) => {
  if (isServer) return null
  window.scrollTo({
    top: 0,
    left: 0,
    behavior,
  })
}
